module.exports = __webpack_public_path__ + "static/profile_photo-d204e0b5619e54a74c051b2410ba3ec5.png";